import React, {useState} from "react";
import styled from "styled-components";
import TextField from "material-ui/TextField";

import {IssueId} from "common/types/issue";
import {QueryDomain, isQueryDomain} from "common/types/query_domain";
import tryParseJSON from "common/utils/try_parse";

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
`;

const Title = styled.div`
  color: rgb(66, 165, 245);
  font-weight: 500;
  font-size: 15px;
`;

interface Props {
  /**
   * Callback invoked with new LLMResponse value on change. This callback is
   * only invoked when the user's input parses to valid JSON of the correct
   * structure for @type LLMResponse.
   */
  onChange: (newValue: QueryDomain) => void;
  /**
   * Controlled value of this input. Currently synchronised crudely (on-mount).
   * A better policy in general would be to override the local state of this
   * component with this value as a simple side-effect of it changing.
   */
  value: QueryDomain;

  issueId: IssueId;
}

function getDefaultState(value) {
  return value ? JSON.stringify(value) : "{}";
}

const QueryDomainEditor = ({onChange, value, issueId}: Props) => {
  const [state, setState] = useState(getDefaultState(value));
  React.useEffect(() => setState(getDefaultState(value)), [issueId]);

  const [hasError, setHasError] = useState(false);

  return (
    <Container>
      <Title>Query Domain</Title>
      <TextField
        style={{width: "100%", fontFamily: "monospace", fontSize: "0.8rem"}}
        value={state}
        onChange={event => setState(event.target.value)}
        onBlur={() => {
          const parsed = tryParseJSON(state);
          if (!parsed.ok || !isQueryDomain(parsed.value)) {
            setHasError(true);
          } else {
            onChange(parsed.value as QueryDomain);
            setHasError(false);
          }
        }}
        multiLine
        rows={6}
        name="Query Domain"
      />
      {hasError && (
        <>
          <span>Sorry, that didn't parse!</span>
        </>
      )}
    </Container>
  );
};

export default QueryDomainEditor;
